// src/utils/constants.js
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3381/api/v1';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  SESSION_ID: 'session_id',
};

export const ROUTES = {
  HOME: '/',
  CATALOG: '/catalog',
  PRODUCT: '/product/:id',
  CART: '/cart',
  CHECKOUT: '/checkout',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:id',
  FAVORITES: '/favorites',
  CASES: '/cases',
  CASE_DETAIL: '/cases/:id',
  BLOG: '/blog',
  BLOG_POST: '/blog/:id',
  SUPPORT: '/support',
  PROFILE: '/profile',
  LOGIN: '/login',
  REGISTER: '/register',
};

export const ORDER_STATUSES = {
  DRAFT: 'draft',
  PENDING: 'pending',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUSES.DRAFT]: 'Черновик',
  [ORDER_STATUSES.PENDING]: 'Ожидает',
  [ORDER_STATUSES.PROCESSING]: 'В обработке',
  [ORDER_STATUSES.SHIPPED]: 'Отправлен',
  [ORDER_STATUSES.DELIVERED]: 'Доставлен',
  [ORDER_STATUSES.COMPLETED]: 'Завершен',
  [ORDER_STATUSES.CANCELLED]: 'Отменен',
  [ORDER_STATUSES.REFUNDED]: 'Возвращен',
};

export const PAYMENT_STATUSES = {
  PENDING: 'pending',
  PAID: 'paid',
  FAILED: 'failed',
  REFUNDED: 'refunded',
};

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUSES.PENDING]: 'Ожидает оплаты',
  [PAYMENT_STATUSES.PAID]: 'Оплачен',
  [PAYMENT_STATUSES.FAILED]: 'Ошибка оплаты',
  [PAYMENT_STATUSES.REFUNDED]: 'Возврат',
};